import React from 'react'

const Button = ({name}) => {
  return (
    <div>
        <button className="px-3 m-2 py-1 bg-gray-100 rounded-lg  hover:bg-gray-200 font-sans">{name}</button>
    </div>
  )
}

export default Button